function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 2.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2,13.32324a1.609,1.609,0,0,0,.51,1.17,1.609,1.609,0,0,0,1.17.51H15.32a1.74529,1.74529,0,0,0,1.68-1.68v-10H2Zm3.46-7.15,1.05-1.05,2.99,2.99,2.99-2.99,1.05,1.05L10.55,9.16327l2.99,2.99-1.05,1.05-2.99-2.99-2.99,2.99-1.05-1.05,2.99-2.99Z"
});

var SvgIWithoutstock = function SvgIWithoutstock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 19 15.00323",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIWithoutstock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i_withoutstock.dbb571c5.svg";
export { ForwardRef as ReactComponent };